import { QueryClient } from "@tanstack/react-query";
import { isNonRetryableApiError } from "../managers/api/errors";

const MAX_RETRIES = 3;

export function createQueryClient(): QueryClient {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                // Faits de session : ils restent en cache, sans rechargement, jusqu'au dispose().
                staleTime: Infinity,
                gcTime: Infinity,
                retry: (failureCount, error) =>
                    !isNonRetryableApiError(error) &&
                    failureCount < MAX_RETRIES,
            },
        },
    });
    queryClient.mount();

    return queryClient;
}
